import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'

export class IMEIAuthApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/auth/CheckIMEIAuth',
      requesterInfo,
    })
  }

  public async checkAuth(): Promise<any> {
    return await this.getAsync<any>()
  }
}
